export enum ScheduleStatus {
  PENDING = 'PENDING',
  EXECUTED = 'EXECUTED',
}
